import React from 'react';

import SvgContainer from '../SvgContainer';

const ArrowLeft = () => {
    return (
        <SvgContainer>
            <path d="M12.1972 2.18735C12.6328 1.77662 12.6328 1.08399 12.1972 0.673251C11.7963 0.295209 11.1702 0.295209 10.7694 0.673251L3.77148 7.27247C3.35292 7.66719 3.35292 8.33281 3.77148 8.72753L10.7694 15.3267C11.1702 15.7048 11.7963 15.7048 12.1972 15.3267C12.6328 14.916 12.6328 14.2234 12.1972 13.8126L6.03342 8L12.1972 2.18735Z" />
        </SvgContainer>
    );
};

export default ArrowLeft;
